import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Input,
  Button,
  Card,
  Spinner,
  Icon,
  MediaObject,
  ColorPicker,
} from '@salesforce/design-system-react';

const SlideGenComponent = (props) => {
  const [logoUrl, setLogoUrl] = useState(
    'https://www.salesforce.com/news/wp-content/uploads/sites/3/2020/10/Salesforce_Corporate_Logo_RGB.jpg'
  );
  const [email, setEmail] = useState('');
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');

  const [data, setData] = useState({});

  useEffect(() => {
    if (isProd()) {
      setEmail(props.journeyEmail);
    }

    const fetchData = async () => {
      const result = await axios.get(`/api/slides/${props.journeyId}`);

      setData(result.data);
    };

    fetchData();
  }, [props.journeyId]);

  const isDisabled = () => {
    if (logoUrl.length === 0 || email.length === 0) {
      return true;
    }
    return false;
  };

  const isProd = () => {
    return (
      process.env.NODE_ENV === 'production' ||
      process.env.NODE_ENV === 'staging'
    );
  };

  const handleChangePrimary = (event, data) => {
    const dataAsArray = Object.keys(data).map((key) => data[key]);
    setPrimaryColor(dataAsArray[0]);
  };

  const handleChangeSecondary = (event, data) => {
    const dataAsArray = Object.keys(data).map((key) => data[key]);
    setSecondaryColor(dataAsArray[0]);
  };


  return (
    <Card
      hasNoHeader
      className="slds-p-horizontal_small"
      style={{
        backgroundColor: '#f3f3f3',
        border: '1px solid #ccc',
      }}
    >
      <MediaObject
        body={
          <span>
            <strong>Step 2: &nbsp;</strong>
            Generate the Slide Deck
          </span>
        }
        figure={
          <Icon
            category="standard"
            name="file"
            size="medium"
            containerStyle={{
              backgroundColor: '#fcb95b',
            }}
          />
        }
        verticalCenter
      />
      {props.isSlidesLoading ? (
        <Spinner assistiveText={{ label: 'loading' }} />
      ) : null}
      <div className="slds-p-horizontal_small">
        <Input
          className="slds-m-around_small"
          label="Add the Company Logo URL"
          required
          value={logoUrl}
          onChange={(e) => setLogoUrl(e.target.value)}
          placeholder="Enter Company Logo URL"
        ></Input>
        {isProd() ? null : (
          <Input
            className="slds-m-around_small"
            label="Email (testing)"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email to share slides with"
          ></Input>
        )}
  
        {/* <ColorPicker
          events={{ onChange: handleChangePrimary }}
          value={primaryColor}
          className="slds-col slds-p-around_x-small"
          labels={{ label: 'Primary Company Color' }}
          id="primary-color-picker"
        />
        <ColorPicker
          events={{ onChange: handleChangeSecondary }}
          value={secondaryColor}
          className="slds-col slds-p-around_x-small"
          labels={{ label: 'Secondary Company Color' }}
          id="secondary-color-picker"
        /> */}

        <Button
          key="promptBtn"
          className="slds-align_absolute-center slds-m-bottom_small slds-m-top_small"
          variant="brand"
          label="Generate Slides"
          disabled={isDisabled()}
          onClick={() =>
            props.createSlides(logoUrl, email, props.journeyId, primaryColor, secondaryColor, 'slides')
          }
        />
      </div>
    </Card>
  );
};

export default SlideGenComponent;
